import React from "react";
import { Card, CardContent, Box, Skeleton, Button } from "@mui/material";
import "../ProductCard/ProductCard.css"; // Keeps same base styling as ProductCard

const SkeletonProductCard = () => {
    return (
        <Card className="product-card">
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                {/* 🔹 Image placeholder */}
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={"200px"}
                    sx={{ borderRadius: "4px 4px 0 0" }}
                />

                <CardContent sx={{ textAlign: "center", width: "100%" }}>
                    {/* 🔹 Product Name */}
                    <Skeleton variant="text" width="80%" height={24} sx={{ mx: "auto", mb: 0.5 }} />
                    {/* 🔹 Product Number */}
                    <Skeleton variant="text" width="60%" height={18} sx={{ mx: "auto", mb: 0.5 }} />
                    {/* 🔹 RSPL Type */}
                    <Skeleton variant="text" width="70%" height={18} sx={{ mx: "auto", mb: 1 }} />
                    {/* 🔹 Price */}
                    <Skeleton variant="text" width="40%" height={22} sx={{ mx: "auto", mb: 1 }} />
                    {/* 🔹 Add to Cart / Request Button */}
                    <Skeleton
                        variant="rectangular"
                        width={120}
                        height={36}
                        sx={{ mx: "auto", borderRadius: 1 }}
                    />
                </CardContent>
            </Box>
        </Card>
    );
};

export default SkeletonProductCard;
